import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
} from '@chakra-ui/react';

import TestResultsRegisteredUsersTable from './TestResultsRegisteredUsersTable';
import TestResultsNotRegisteredUsersTable from './TestResultsNotRegisteredUsersTable';
import TestResultsSummary from './TestResultsSummary';

const TestResultsModal = ({ data, isOpen, onClose, companyId }) => {
  const { summary, registered, notRegistered } = data || {
    summary: null,
    registered: [],
    notRegistered: [],
  };

  if (!summary) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent height="180px">
          <ModalCloseButton position="absolute" left="8px" right="auto" top="8px" zIndex="1" />
          <ModalHeader>תוצאות בדיקה</ModalHeader>
          <ModalBody>
            <Text>אין נתונים להצגה</Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW="95%" maxH="92vh" overflow="hidden">
        <ModalCloseButton position="absolute" left="8px" right="auto" top="8px" zIndex="3" />
        <ModalHeader position="sticky" top="0" bg="white" zIndex="2" px={6} py={4}>
          תוצאות בדיקה
        </ModalHeader>
        <ModalBody pb={6} overflowY="auto">
          <TestResultsSummary
            summary={{ ...summary, registered, notRegistered }}
            companyId={companyId}
          />

          <Box mb={6}>
            <TestResultsRegisteredUsersTable registered={registered} />
          </Box>

          <Box mb={6}>
            <TestResultsNotRegisteredUsersTable notRegistered={notRegistered} />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TestResultsModal;
